import { render, staticRenderFns } from "./FeedIngredient.vue?vue&type=template&id=13a64b96&scoped=true"
import script from "./FeedIngredient.vue?vue&type=script&lang=js"
export * from "./FeedIngredient.vue?vue&type=script&lang=js"
import style0 from "./FeedIngredient.vue?vue&type=style&index=0&id=13a64b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a64b96",
  null
  
)

export default component.exports